/**
 * Značka obchodu.
 *
 * Originál (`/logo.png`) je kreslený na tmavé pozadí – „Super" je bílé,
 * „Krmivo" značkově zelené (pes je v „u", kočka v „o"). Na světlé hlavičce
 * by z něj byla vidět jen zelená polovina, proto se vedle něj vozí varianta
 * `/logo-ink.png` s prohozenou šedou škálou: „Super" je černé, zelená se
 * nemění. Kresba je v obou stejná.
 *
 * Přepíná to `<picture>` přes `prefers-color-scheme`, ne JavaScript:
 * prohlížeč tak stáhne rovnou tu správnou a při přepnutí motivu se
 * nemusí nic překreslovat.
 */
export function Logo({ compact = false }: { compact?: boolean }) {
  return (
    <picture className={compact ? 'logo is-compact' : 'logo'}>
      <source srcSet="/logo.png" media="(prefers-color-scheme: dark)" />
      <img src="/logo-ink.png" alt="Super Krmivo" width="2172" height="724" />
    </picture>
  );
}
